import { z } from "zod";

const SOCIAL_URL_PATTERNS = {
	linkedin: { regex: /^https:\/\/(www\.)?linkedin\.com\/.+/, message: "LinkedIn URL must start with https://linkedin.com/" },
	x: { regex: /^https:\/\/(www\.)?(x|twitter)\.com\/.+/, message: "X URL must start with https://x.com/ or https://twitter.com/" },
	github: { regex: /^https:\/\/(www\.)?github\.com\/.+/, message: "GitHub URL must start with https://github.com/" },
	instagram: { regex: /^https:\/\/(www\.)?instagram\.com\/.+/, message: "Instagram URL must start with https://instagram.com/" },
	facebook: { regex: /^https:\/\/(www\.)?facebook\.com\/.+/, message: "Facebook URL must start with https://facebook.com/" },
} as const;

const socialUrl = (key: keyof typeof SOCIAL_URL_PATTERNS) =>
	z
		.url({ message: "Invalid URL" })
		.refine((value) => SOCIAL_URL_PATTERNS[key].regex.test(value), { message: SOCIAL_URL_PATTERNS[key].message })
		.nullish();

export const socialLinksSchema = z
	.object({
		linkedin: socialUrl("linkedin"),
		x: socialUrl("x"),
		github: socialUrl("github"),
		instagram: socialUrl("instagram"),
		facebook: socialUrl("facebook"),
	})
	.strict();

export type SocialLinks = z.infer<typeof socialLinksSchema>;

export type SocialLinkKey = keyof SocialLinks;

export const SOCIAL_LINK_KEYS: SocialLinkKey[] = ["linkedin", "x", "github", "instagram", "facebook"];
